// https://hexdocs.pm/phoenix/js/
/*eslint-disable*/
import type { SocketConnectOption } from 'phoenix';
import { Socket } from 'phoenix';
import React, { useEffect, useState } from 'react';
import { useSessionStore } from 'store/session';

export const SocketContext = React.createContext<Socket | null>(null);

interface SocketProviderProps {
  children: React.ReactNode;
  url?: string;
  options?: Partial<SocketConnectOption>;
}

export function SocketProvider({
  children,
  options,
  url,
}: SocketProviderProps) {
  const [socket, setSocket] = useState<Socket | null>(null);
  const { session } = useSessionStore();

  useEffect(() => {
    if (!url) {
      return;
    }

    const socketInstance = new Socket(url, {
      params: {
        pingauthorization: `Bearer ${session}`,
      },
      // @TODO: may need enable below later for move token into header
      // transport: class extends WebSocket {
      //   constructor(url: string) {
      //     super(url, [`${session}`]);
      //   }
      // },
    });

    try {
      if (session) {
        socketInstance.connect();
      }
    } catch (error) {
      console.error('error', error);
    }

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
      setSocket(null);
    };
  }, [options, url, session]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}

export function useSocket() {
  const context = React.useContext(SocketContext);
  if (context === undefined) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
}
